package one.healthium.healthKit.data

enum class HealthKitStatus {
    UNKNOWN,
    REJECTED,
    CONNECTED,
    CONNECTING,
    UNAVAILABLE,
    CLIENT_REQUIRES_UPDATE,
}